import React, { Fragment } from 'react';
import { useNavigate } from "react-router-dom";
import ListingPageComponent from '../../components/ListingPageComponent';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import UI_ACTIONS from '../../data/UiActionConstants';
import { getApi } from '../../api/endpoints';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import UiAction from '../../components/UiAction';

const Index = () => {
  const navigate = useNavigate();
  const defaultHeaderConfig = { disableSort: true };
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name',
    },
    {
      ...defaultHeaderConfig,
      label: 'Circle',
      attr: 'branch_name',
    },
    {
      ...defaultHeaderConfig,
      label: 'SLOC',
      attr: 'sloc',
    },
    {
      ...defaultHeaderConfig,
      label: 'SAP Code',
      attr: 'tally_account_id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Warehouse Name',
      value: (row) => {
        return <div className="d-block">
          {row.ware_house_name === null ? "-" : row.ware_house_name}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at',
      disableSort: false
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_service_center.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onViewClick(row.id) }>
              <FontAwesomeIcon icon={faEye}/>
            </div>
          </UiAction>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_service_center.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onEditClick(row.id) }>
              <FontAwesomeIcon icon={faEdit}/>
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  const onViewClick = (id) => {
    navigate(`/service_centers/${id}`)
  }

  const onEditClick = (id) => {
    navigate(`/service_centers/${id}/edit`)
  }

  const onNewClick = () => {
    navigate(`/service_centers/new`)
  }

  const tableHeaderActionsComponent = () => {
    return <Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_service_center.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add Service Center</span>
        </button>
      </UiAction>
    </Fragment>
  }

  return <ListingPageComponent
    key={PAGES.ServiceCentersListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.ServiceCentersListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Service Centers', url:"/service_centers"}]}
    listingMutation={getApi('serviceCenters')}
    className="service-centers-listing-page"
    contentHeading="Service Centers - Results"
    headers={headers}
    recordsKey="service_centers"
    tableHeaderActionsComponent={tableHeaderActionsComponent()}
    searchBy={['ID', 'Name', 'SLOC']}
  />
};

export default Index;


